module.exports = __webpack_public_path__ + "img/4-1.a1cc97d6.svg";